import { useState } from 'react';

import { calendarClasses } from './date-picker-calendar.styles';
import { CalendarMenuProps, DatePickerActionType } from './date-picker.types';
import { ChevronLeftIcon, ChevronRightIcon } from '../..';

export const YearMenu = (props: CalendarMenuProps) => {
  const { state, dispatch } = props;
  const [decade, setDecade] = useState(Math.floor(state.year / 10) * 10);
  const years = [];
  const start = decade - 1;
  const end = decade + 10;
  for (let i = start; i <= end; ++i) {
    years.push(
      <button
        key={i}
        className={calendarClasses.menuButtonClasses}
        onClick={() => dispatch({ type: DatePickerActionType.SET_YEAR, year: i })}
      >
        {i}
      </button>
    );
  }
  return (
    <div className={calendarClasses.containerClasses}>
      <div className={calendarClasses.headerClasses}>
        <div className="flex">
          <div className={calendarClasses.monthTextClasses}>{state.year} </div>
          <button
            title="prev decade"
            className={calendarClasses.monthButtonClasses}
            onClick={() => setDecade(decade - 10)}
          >
            <ChevronLeftIcon className={calendarClasses.monthButtonIconClasses} />
          </button>
          <button
            title="next decade"
            className={calendarClasses.monthButtonClasses}
            onClick={() => setDecade(decade + 10)}
          >
            <ChevronRightIcon className={calendarClasses.monthButtonIconClasses} />
          </button>
        </div>
      </div>
      <div className={calendarClasses.monthGridClasses}>{years}</div>
    </div>
  );
};
